"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TokenModels_1 = __importDefault(require("ContentTokens/TokenModels"));
var UploadUtils_1 = require("Common/Upload/UploadUtils");
exports.default = (function (transfer, uploadStore) {
    var files = transfer.files;
    return files
        .map(function (file) {
        if ((0, UploadUtils_1.isImage)(file)) {
            return getImageToken(uploadStore, file);
        }
        else {
            return;
        }
    })
        .filter(function (token) { return !!token; });
});
var getImageToken = function (uploadStore, file) {
    var uploadId = uploadStore.upload(file);
    return TokenModels_1.default.image.createToken("", { uploadId: uploadId });
};
